/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface TestGetHandlerResponse {
  code: number | null;
  data: {
    /** @minLength 1 */
    _id: string;
    isAfterDoc?: boolean;
    phone?: string;
    visit?: string;
    status?: string;
  };
  message: string;
}

export interface TestPostHandlerBodyRequest {
  /** @minLength 1 */
  uid: string;
  name: string | null;
  /** @min 18 */
  age?: number;
  operator?: string;
  array: string[] | null;
  object?: {
    /** @minLength 1 */
    id: string;
    number: number;
  };
}

export interface TestPostHandlerResponse {
  uid: string;
  name: string;
  age: number | null;
  operator: string;
  array: string[] | null;
  object: {
    /** @minLength 1 */
    id: string;
    number: number;
  } | null;
  original: {
    /** @minLength 1 */
    uid: string;
    name: string | null;
    /** @min 18 */
    age?: number;
    operator?: string;
    array: string[] | null;
    object?: {
      /** @minLength 1 */
      id: string;
      number: number;
    };
  };
}

export interface TestPutHandlerBodyRequest {
  uid: string;
  name?: string | null;
  /** @min 18 */
  age: number | null;
  operator?: string;
}

export interface TestPutHandlerResponse {
  uid: string;
  name: string;
  age: number;
  operator: string;
}

export interface TestPatchHandlerBodyRequest {
  uid: string;
  name?: string | null;
  /** @min 18 */
  age: number | null;
  operator?: string;
}

export interface TestPatchHandlerResponse {
  uid: string;
  name: string;
  age: number;
  operator: string;
}

export interface TestDeleteHandlerResponse {
  uid: string;
  name: string;
  age: number;
  operator: string;
}

export interface TestChatElFindHandlerResponse {
  code: string;
  data: {
    /** 채팅 모델이 귀속된 채팅방 ID */
    chatRoomID?: string;
    /** 발송된 채팅 모델의 타입 */
    type?: number | null;
    /** 채팅 내 전달된 메세지 */
    content: string;
    /** 번역된 메세지 */
    translatedContent?: string;
    /** 번역된 메세지를 재번역한 메세지 */
    retranslatedContent?: string;
    /**
     * 번역 완료 여부
     * @default false
     */
    isTranslated?: boolean;
    /**
     * 채팅 발송 여부
     * @default false
     */
    isSendContent?: boolean;
    /** 채팅 발송 유저의 Type */
    userType?: number | null;
    /** 채팅을 발송한 유저의 ID */
    userID?: string;
    /** 첨부된 파일의 ID 배열 */
    fileIDs?: any[];
    /** 채팅으로 전송된 운동콘텐츠 ID 배열 */
    videoContentIDs?: any[];
    /** 채팅으로 전송된 병원 이벤트 - 이벤트에 대한 ID */
    heventID?: any;
    /** 채팅으로 전송된 병원 이벤트 - 홈케어 상품에 대한 ID */
    haftercareID?: any;
    /** 채팅으로 전송된 병원 공지사항에 대한 ID */
    hnoticeID?: any;
    /**
     * 채팅의 북마크 여부
     * @default false
     */
    isBookmark: boolean;
    /** 채팅의 북마크 지정 시간 */
    bookmarkedAt?: string;
    /** 미사용 */
    user?: Record<string, any>;
    /** 파일 전송 시  파일 업로드 이전에 임시로 생성된 경우에 사용될 ID */
    tempID?: string;
    /** 채팅 마커에 사용될 이모지 배열 */
    markers?: any[];
    /** 발송한 유저의 이름 */
    userName?: string;
    /** 채팅 발신자의 직책 */
    jobType?: string;
    /** 유저의 실제 이름 */
    userRealName?: string;
    /** 발송한 유저의 프로필 이미지 URL */
    photoPath?: string;
    /** 상담 알고리즘의 Identifier (임시) */
    caName?: string;
    /** 상담 알고리즘의 사이클 Identifier */
    caCycle?: string;
    /** 생성일 */
    createdAt?: string;
    /** 마지막 수정일 */
    updatedAt?: string;
    /** 메시지의 ID */
    _id: string;
    /** 메시지 발송일 */
    sentAt: string;
    /** AI 상담 코치 데이터 */
    aiCoach?: {
      language?: string | null;
      source?: "COACH" | "GLOBAL_COORDINATOR" | null;
      responseText?: string | null;
      translatedResponseText?: string | null;
      responseGuide?: string | null;
      automaticResponseIntervalMinutes?: number | null;
      status?: "PROCESSING" | "FAILED" | "COMPLETED" | null;
      handsoff?: {
        reason?: "APPOINTMENT_NEED_CONFIRMATION" | "UNABLE_TO_RESPOND" | null;
        message?: string | null;
        translatedMessage?: string | null;
      };
      references?: string[] | null;
      isSourceAppInactive?: boolean | null;
      hasDeferredSideEffects?: boolean | null;
    };
  }[][];
  message: string;
}

export interface TestChatElSendHnoticeHandlerBodyRequest {
  /** (required) 전송할 병원 서비스ID ObjectId */
  hserviceID: string;
  /** (required) 전송할 채팅방 ObjectId */
  chatRoomID: string;
  /** (required) 전송할 병원 공지사항 ObjectId */
  hnoticeID: string;
}

export interface TestChatElSendHnoticeHandlerResponse {
  code: string;
  data: {
    /** 채팅 모델이 귀속된 채팅방 ID */
    chatRoomID?: string;
    /** 발송된 채팅 모델의 타입 */
    type?: number | null;
    /** 채팅 내 전달된 메세지 */
    content: string;
    /** 번역된 메세지 */
    translatedContent?: string;
    /** 번역된 메세지를 재번역한 메세지 */
    retranslatedContent?: string;
    /**
     * 번역 완료 여부
     * @default false
     */
    isTranslated?: boolean;
    /**
     * 채팅 발송 여부
     * @default false
     */
    isSendContent?: boolean;
    /** 채팅 발송 유저의 Type */
    userType?: number | null;
    /** 채팅을 발송한 유저의 ID */
    userID?: string;
    /** 첨부된 파일의 ID 배열 */
    fileIDs?: any[];
    /** 채팅으로 전송된 운동콘텐츠 ID 배열 */
    videoContentIDs?: any[];
    /** 채팅으로 전송된 병원 이벤트 - 이벤트에 대한 ID */
    heventID?: any;
    /** 채팅으로 전송된 병원 이벤트 - 홈케어 상품에 대한 ID */
    haftercareID?: any;
    /** 채팅으로 전송된 병원 공지사항에 대한 ID */
    hnoticeID?: any;
    /**
     * 채팅의 북마크 여부
     * @default false
     */
    isBookmark: boolean;
    /** 채팅의 북마크 지정 시간 */
    bookmarkedAt?: string;
    /** 미사용 */
    user?: Record<string, any>;
    /** 파일 전송 시  파일 업로드 이전에 임시로 생성된 경우에 사용될 ID */
    tempID?: string;
    /** 채팅 마커에 사용될 이모지 배열 */
    markers?: any[];
    /** 발송한 유저의 이름 */
    userName?: string;
    /** 채팅 발신자의 직책 */
    jobType?: string;
    /** 유저의 실제 이름 */
    userRealName?: string;
    /** 발송한 유저의 프로필 이미지 URL */
    photoPath?: string;
    /** 상담 알고리즘의 Identifier (임시) */
    caName?: string;
    /** 상담 알고리즘의 사이클 Identifier */
    caCycle?: string;
    /** 생성일 */
    createdAt?: string;
    /** 마지막 수정일 */
    updatedAt?: string;
    /** 메시지의 ID */
    _id: string;
    /** 메시지 발송일 */
    sentAt: string;
    /** AI 상담 코치 데이터 */
    aiCoach?: {
      language?: string | null;
      source?: "COACH" | "GLOBAL_COORDINATOR" | null;
      responseText?: string | null;
      translatedResponseText?: string | null;
      responseGuide?: string | null;
      automaticResponseIntervalMinutes?: number | null;
      status?: "PROCESSING" | "FAILED" | "COMPLETED" | null;
      handsoff?: {
        reason?: "APPOINTMENT_NEED_CONFIRMATION" | "UNABLE_TO_RESPOND" | null;
        message?: string | null;
        translatedMessage?: string | null;
      };
      references?: string[] | null;
      isSourceAppInactive?: boolean | null;
      hasDeferredSideEffects?: boolean | null;
    };
  }[];
  message: string;
}

export interface TestGetHandlerParams {
  userID?: string;
}

export type TestGetHandlerData = TestGetHandlerResponse;

export type TestPostHandlerData = TestPostHandlerResponse;

export type TestPutHandlerData = TestPutHandlerResponse;

export type TestPatchHandlerData = TestPatchHandlerResponse;

export interface TestDeleteHandlerParams {
  uid: string;
  name?: string | null;
  /** @min 18 */
  age?: number | null;
  operator?: string;
}

export type TestDeleteHandlerData = TestDeleteHandlerResponse;

export interface TestChatElFindHandlerParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  isDoctor?: boolean;
  isRemoved?: boolean;
  /** 1대1 채팅방 구분자 */
  isMultiUser?: boolean;
  /** 검색 키워드 - 환자 채팅방 제목 또는 관리자 채팅방 개별 제목 검색 */
  keyword?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number | null;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number | null;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number | null;
}

export type TestChatElFindHandlerData = TestChatElFindHandlerResponse;

export type TestChatElSendHnoticeHandlerData = TestChatElSendHnoticeHandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description Get a user
     *
     * @tags TEST
     * @name TestGetHandler
     * @summary Get a user
     * @request GET:/api/test/get
     * @secure
     * @response `200` `TestGetHandlerData` success
     */
    testGetHandler: (query: TestGetHandlerParams, params: RequestParams = {}) =>
      this.request<TestGetHandlerData, any>({
        path: `/api/test/get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new user
     *
     * @tags TEST
     * @name TestPostHandler
     * @summary Create a new user
     * @request POST:/api/test/post
     * @secure
     * @response `200` `TestPostHandlerData` success
     */
    testPostHandler: (data: TestPostHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<TestPostHandlerData, any>({
        path: `/api/test/post`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Put user
     *
     * @tags TEST
     * @name TestPutHandler
     * @summary Preate user
     * @request PUT:/api/test/put
     * @secure
     * @response `200` `TestPutHandlerData` success
     */
    testPutHandler: (data: TestPutHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<TestPutHandlerData, any>({
        path: `/api/test/put`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description patch user
     *
     * @tags TEST
     * @name TestPatchHandler
     * @summary patch user
     * @request PATCH:/api/test/patch
     * @secure
     * @response `200` `TestPatchHandlerData` success
     */
    testPatchHandler: (data: TestPatchHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<TestPatchHandlerData, any>({
        path: `/api/test/patch`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a user
     *
     * @tags TEST
     * @name TestDeleteHandler
     * @summary Delete a user
     * @request DELETE:/api/test/delete
     * @secure
     * @response `200` `TestDeleteHandlerData` success
     */
    testDeleteHandler: (query: TestDeleteHandlerParams, params: RequestParams = {}) =>
      this.request<TestDeleteHandlerData, any>({
        path: `/api/test/delete`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description find chats
     *
     * @tags TEST
     * @name TestChatElFindHandler
     * @summary find chats
     * @request GET:/api/test/chat_el_find
     * @secure
     * @response `200` `TestChatElFindHandlerData` success
     */
    testChatElFindHandler: (query: TestChatElFindHandlerParams, params: RequestParams = {}) =>
      this.request<TestChatElFindHandlerData, any>({
        path: `/api/test/chat_el_find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description send chat - hospital notice
     *
     * @tags TEST
     * @name TestChatElSendHnoticeHandler
     * @summary send chat - hospital notice
     * @request POST:/api/test/chat_el_send_hnotice
     * @secure
     * @response `200` `TestChatElSendHnoticeHandlerData` success
     */
    testChatElSendHnoticeHandler: (data: TestChatElSendHnoticeHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<TestChatElSendHnoticeHandlerData, any>({
        path: `/api/test/chat_el_send_hnotice`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
